export const Messages = {
  noUpdates: 'No updates are available',
  updatesNotice: 'PMM checks for upgrades once a day',
  upToDate: 'You are up to date',
  noAccess: 'Insufficient access permissions',
  updatesDisabled: 'Upgrades are disabled. You can enable them in ',
  pmmSettings: 'PMM Settings.',
  notOnline: 'PMM cannot check for upgrades',
};
